<template>
<div>
<SelectSubject/>

</div>
</template>
<script>
import SelectSubject from "../../components/academic/SelectSubject.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   SelectSubject
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>